import axios from 'axios';

const url = process.env.REACT_APP_API_URL;

if (!url) 
    throw new Error('The REACT_APP_API_URL environment variable was not configured!');

const api = axios.create({
    baseURL: url
});

const setAuthorizationToken = (token: string | null) => 
    api.defaults.headers.Authorization = token ? `Bearer ${token}` : null;

export { setAuthorizationToken };
export default api;